import React from 'react'
import { FormHelperText, Typography } from '@mui/material'
import { FormControl } from '@mui/material'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { Dayjs } from 'dayjs'
import tw from 'twin.macro'

interface Props {
  name?: string
  label?: string
  value?: Dayjs
  error?: boolean
  helperText?: string | false
  onChange(date: Dayjs | null): void
}

export interface BasicSelectOption {
  label: string
  value: string | number
}

export const BasicTimePicker = ({ label, value, error, helperText, onChange }: Props) => {
  return (
    <FormControl fullWidth error={error}>
      <div css={tw`space-y-1`}>
        <Typography variant="h6" css={tw`text-shades-400`}>
          {label}
        </Typography>
        <TimePicker value={value} onChange={onChange} />
        {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
      </div>
    </FormControl>
  )
}
